// Site Configurations for Kempinski Boutique
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@kempinskiboutique.com';
export const siteName = 'Kempinski Boutique'; // Used in meta tags, for copy interpolation, etc.
export const parentHotelCompany = 'Kempinski';
export const hotelBrandName = 'Kempinski Boutique';
// Salesforce list tags for the Kempinski Hotels brand opt-in (footer, lightbox and checkout), sent to
// NEXT_PUBLIC_SF_API and stored on the subscriber's row in Website_Signups. Store sends filter on
// `subscribedList IS NULL OR = 'KEM_BrandNews'`, so brand-only sign-ups get their own tag.
export const brandSubscribedList = 'KEM_BrandNews'; // store + brand
export const brandOnlySubscribedList = 'KEM_Brand'; // brand only
export const catalogId = 'KEM';
export const region = 'EU';
export const scandiWebMenuId = 'kem';
export const companyTelephone = '+0141515513';

export const LOGO_IMAGE = { src: '/images/misc/KEM_logo.svg', alt: 'Kempinski Boutique' };

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 719,
  imageHeight: 570,
  imageWidthThumbnail: 500,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
  alternateCtaPosition: 'heading',
};

export const checkout = {
  placeholderLabels: true,
  radioButtons: true,
  paymentMethodProceedButton: true,
  brandSubscribeCheckbox: true,
};

export const header = {
  leftDrawerUtilities: true,
};

export const footer = {
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
};

// Homepage Hero Banner Season
// - Flip to 'winter' for the winter/holiday campaign, back to 'summer' once it ends.
// - Swaps both the hero background image and the snowfall overlay animation (winter only).
export const heroSection = {
  season: 'summer' as 'summer' | 'winter',
};
export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'KEM - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};
// Misc
export const firstVisitModal = {
  modalWidth: 550,
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
};

// Adobe Launch Settings
// - Not applicable for Kempinski (not a Marriott brand)
// Removed Marriott-specific settings

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-MVT4HCD';

// Zendesk Web Widget (chat) key
export const zendeskKey = '8249f1d4-5ac1-4ab9-b152-b1a6964183f0';
export const productNameFilters = {
  replacements: [{ target: 'The Kempinski', replacement: 'Kempinski' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// CloudWatch RUM (Real User Monitoring)
// Loaded by useRumScript hook in App.tsx, gated on Cookiebot statistics consent.
// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: '17616563-3d27-40d5-9a52-73afb2ad07e5',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'rTuzoeqK2xbCAQ9JM4h5LP8uIpqzPm6GVEh2-3boTTE';
export const defaultOgImage = '/images/homepage/heroSection/kem-hero-bg-dsktp.webp';

// Links to international sites
// To be configured if Kempinski has international sites
export const INTL_SITES = [
  {
    region: 'NA',
    links: [],
  },
  {
    region: 'APAC',
    links: [
      {
        value: 'English',
        url: 'https://www.kempinskiboutique.cn/en/?___store=kemcn_en',
      },
      {
        value: '简体中文',
        url: 'https://www.kempinskiboutique.cn/zh-CN/?___store=kemcn_cn',
      },
    ],
  },
];
